export interface SongMetadata {
  file: any;
  title: string;
  album: string;
  artist: string;
  art: any;
}

export const SongBank: SongMetadata[] = [
  {
    file: require(`@/assets/caravan-music/Kavinsky - Nightcall.mp3`),
    title: `Nightcall`,
    album: `Nightcall`,
    artist: `Kavinsky`,
    art: require(`@/assets/caravan-music/AlbumArtworks/KavinskyNightcall.jpg`)
  },
  {
    file: require(`@/assets/caravan-music/Mitch Murder - Telefuture Theme.mp3`),
    title: `Telefuture Theme`,
    album: `Current Events`,
    artist: `mitch murder`,
    art: require(`@/assets/caravan-music/AlbumArtworks/mitchmurderCurrentEvents.jpg`)
  },
  {
    file: require(`@/assets/caravan-music/Nightcrawler - Metropolis - 10 Genesis (Feat. Dana Jean Phoenix).mp3`),
    title: `Genesis (Feat. Dana Jean Phoenix)`,
    album: `Metropolis`,
    artist: `NightCrawler`,
    art: require(`@/assets/caravan-music/AlbumArtworks/NightCrawlerMetropolis.jpg`)
  },
  {
    file: require(`@/assets/caravan-music/Take Me Away.mp3`),
    title: `Take Me Away`,
    album: `Dreamatic`,
    artist: `FM Attack`,
    art: require(`@/assets/caravan-music/AlbumArtworks/FMAttackDreamatic.jpg`)
  },
  {
    file: require(`@/assets/caravan-music/Tommy '86 - Why Did I Say Goodbye (feat. Sally Shapiro).mp3`),
    title: `Why Did I Say Goodbye (feat. Sally Shapiro)`,
    album: `Frequency Modulations`,
    artist: `Tommy '86`,
    art: require(`@/assets/caravan-music/AlbumArtworks/Tommy86FrequencyModulations.jpg`)
  },
  {
    file: require(`@/assets/caravan-music/asdas/04. M.O.O.N. - Crystals.mp3`),
    title: `Crystals`,
    album: `MOON EP`,
    artist: `M|O|O|N`,
    art: require(`@/assets/caravan-music/AlbumArtworks/MOONMOONEP.jpg`)
  },
  {
    file: require(`@/assets/caravan-music/asdas/08. Jasper Byrne - Hotline.mp3`),
    title: `Hotline`,
    album: `Hotline Miami`,
    artist: `Jasper Byrne`,
    art: require(`@/assets/caravan-music/AlbumArtworks/JasperByrneHotlineMiami.jpg`)
  },
  {
    file: require(`@/assets/caravan-music/asdas/09. Scattle - Knock Knock.mp3`),
    title: `Knock Knock`,
    album: `Timelapse`,
    artist: `Scattle`,
    art: require(`@/assets/caravan-music/AlbumArtworks/ScattleTimelapse.jpg`)
  },
  {
    file: require(`@/assets/caravan-music/asdas/17 New Wave Hookers.mp3`),
    title: `New Wave Hookers`,
    album: `Waxwork`,
    artist: `Vestron Vulture`,
    art: require(`@/assets/caravan-music/AlbumArtworks/VestronVultureWaxwork.jpg`)
  },
  {
    file: require(`@/assets/caravan-music/asdas/20. Scattle - Inner Animal.mp3`),
    title: `Inner Animal`,
    album: `Hotline Miami`,
    artist: `Scattle`,
    art: require(`@/assets/caravan-music/AlbumArtworks/ScattleHotlineMiami.jpg`)
  },
  {
    file: require(`@/assets/caravan-music/asdas/sdfs/02 - Blood Dragon Theme.mp3`),
    title: `Blood Dragon Theme`,
    album: `Far Cry 3: Blood Dragon`,
    artist: `Power Glove`,
    art: require(`@/assets/caravan-music/AlbumArtworks/PowerGloveFarCry3BloodDragon.jpg`)
  },
  {
    file: require(`@/assets/caravan-music/asdas/sdfs/02 - Sexualizer (feat. Flash Arnold).mp3`),
    title: `Sexualizer (feat. Flash Arnold)`,
    album: `Sexualizer`,
    artist: `Perturbator`,
    art: require(`@/assets/caravan-music/AlbumArtworks/PerturbatorSexualizer.jpg`)
  },
  {
    file: require(`@/assets/caravan-music/asdas/sdfs/04 - Perturbator - Miami Disco.mp3`),
    title: `Miami Disco`,
    album: `Hotline Miami Soundtrack`,
    artist: `Perturbator`,
    art: require(`@/assets/caravan-music/AlbumArtworks/PerturbatorHotlineMiamiSoundtrack.jpg`)
  }
];
